import React from 'react';
import '../../styles/Breadcrumbs.css';

/**
 * Компонент "Хлебные крошки" для навигации по структуре папок.
 *
 * @component
 * @example
 * const breadcrumbs = [
 *   { id: "root", name: "Главная" },
 *   { id: "123", name: "Документы" },
 *   { id: "456", name: "Отчёты" }
 * ];
 * return (
 *   <Breadcrumbs breadcrumbs={breadcrumbs} onNavigate={handleNavigation} />
 * )
 *
 * @param {Object} props - Свойства компонента.
 * @param {Array} props.breadcrumbs - Массив объектов, представляющих путь в иерархии.
 * @param {string} props.breadcrumbs[].id - Уникальный идентификатор папки.
 * @param {string} props.breadcrumbs[].name - Название папки.
 * @param {Function} props.onNavigate - Функция обработки навигации по хлебным крошкам.
 * @returns {JSX.Element} Компонент "Хлебные крошки" для отображения пути к текущей папке.
 */
const Breadcrumbs = ({ breadcrumbs, onNavigate, t }) => {
  return (
    <div className="breadcrumbs">
      {/* Кнопка для возврата в корневую директорию */}
      <span onClick={() => onNavigate(-1)}>{t?.breadcrumbHome || 'Главная'}</span>

      {/* Генерация пути на основе массива breadcrumbs */}
      {breadcrumbs.map((folder, index) => (
        <span key={`${folder.id}-${index}`} onClick={() => onNavigate(index)}>
          &nbsp; / {folder.name}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;
